import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Tooltip } from "antd";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";

interface QuestionLimitProps extends WithTranslation {
  value: number;
  priority: API_QUESTION_PRIORITY;
}

const priorityMap: { [key in API_QUESTION_PRIORITY]: string } = {
  HIGH: "High",
  NORMAL: "Normal + Low",
  LOW: "Low",
};

export const QuestionLimit = withTranslation(I18N_NS.PROJECT)(({ value, priority, t }: QuestionLimitProps) => {
  let limit: { title: string; icon: IconName; color: string };

  if (value === 0) {
    limit = {
      title: t("You cannot ask any more questions of this priority."),
      icon: "exclamation-circle",
      color: "#ff0000",
    };
  } else if (value) {
    limit = {
      title: t("You may still ask {{value}} more questions of this priority.", { value }),
      icon: "info-circle",
      color: "#0000ff",
    };
  } else {
    limit = {
      title: t("You may ask as many questions as you like for this priority."),
      icon: "info-circle",
      color: "#0000ff",
    };
  }

  return (
    <Tooltip title={limit.title} styles={{ root: { fontSize: "14px" } }}>
      <Row
        align="middle"
        justify="start"
        style={{ backgroundColor: "#F8F4C4", padding: "5px 10px", borderRadius: "20px", marginRight: 5 }}
      >
        <FontAwesomeIcon
          icon={["far", limit.icon as IconName]}
          style={{ color: limit.color, fontSize: "14px", marginRight: "4px" }}
        />
        <span style={{ textTransform: "capitalize" }}>
          {t(priorityMap[priority])}: {typeof value === "number" ? value : t("No limit")}
        </span>
      </Row>
    </Tooltip>
  );
});
